import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

import getListingBasePath from 'Pods/Shared/Utils/getListingBasePath'
import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const STALE_TIME = 10 * 60 * 1000

function fetchUpsellModels(url, params) {
  return axios.get(url, { params }).catch((error) => {
    if (error?.response?.status === 404) {
      return { data: { data: [] } }
    }
    throw error
  })
}

function useUpsellModels({ enabled = false, keywords = '' }) {
  const locale = getLocaleParam()
  const localePrefix = locale ? `/${locale}` : ''
  const listingPath = getListingBasePath()
  const url = `${localePrefix}/${listingPath}.json`

  const { data, isLoading } = useQuery({
    queryKey: ['upsellModels', listingPath, locale, keywords],
    queryFn: () =>
      fetchUpsellModels(url, {
        current_path: listingPath,
        subscribed: 1,
        per_page: 8,
        sort_by: 'best_match',
        keywords,
      }),
    enabled,
    staleTime: STALE_TIME,
    retry: false,
    select: (response) => response?.data?.data || EMPTY_ARRAY,
  })

  return {
    models: data || EMPTY_ARRAY,
    isLoading: enabled && isLoading,
  }
}

export default useUpsellModels
